import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  whichCostFactor: null,
  whichStep: 'review', // review / generate
  additionalData: '',
  isGenerationModelLoader: false,
  selectedVersionBreakdown: null,
  expandedExecutives: {},
  updateMessage: null,
  uniqueId: null,
  initialMessage: null, 
  massUploadFileId: null,
}
const genAiTopDownFlowSlice = createSlice({
  name: 'genAiTopDownFlow',
  initialState: initialState,
  reducers: {
    setGenAiTopDownFlowData(state, action) {
      return { ...state, ...action.payload }
    },
    setWhichCostFactor(state, action) {
      state.whichCostFactor = action.payload
    },
    setWhichStep(state, action) {
      state.whichStep = action.payload
    },
    setAdditionalInput(state, action) {
      state.additionalData = action.payload
    },
    setSelectedVersionBreakdown(state, action) {
      state.selectedVersionBreakdown = action.payload
    },
    setExpandedExecutives(state, action) {
      state.expandedExecutives = { ...state.expandedExecutives, ...action.payload }
    },
    setUpdateMessage(state, action) {
      state.updateMessage = action.payload
    },
    setUniqueId(state, action) {
      state.uniqueId = action.payload
    },
    setInitialMessage(state, action) {
      state.initialMessage = action.payload
    },
    setMassUploadFileId(state, action) {
      state.massUploadFileId = action.payload
    },
    resetGenAiState: () => initialState,
  },
})

export const {
  setGenAiTopDownFlowData,
  setWhichCostFactor,
  setWhichStep,
  setAdditionalInput,
  resetGenAiState,
  setSelectedVersionBreakdown,
  setExpandedExecutives,
  setUpdateMessage,
  setUniqueId,
  setInitialMessage,
  setMassUploadFileId
} = genAiTopDownFlowSlice.actions
export default genAiTopDownFlowSlice.reducer
